import { Component, Prop, Vue } from "vue-property-decorator";
import { fmtMsg } from "commonui";
import { LessonPlanLocale } from "@/locales/localeid";
import { orderBy, uniqBy, groupBy } from "lodash";

export interface LessonPlanEditorVPCNeededProps {
	vpcs?: any[];
}

@Component({
	components: {}
})
export default class LessonPlanEditorVPCNeeded extends Vue {
	@Prop({ default: () => {} }) vpcs!: any[];

	get vpcNeededs() {
		// VPCs should be ordered by sequence in wordspec and vpcs with same sequence should come together.
		const vpcGroups = groupBy(this.vpcs, "typeSequence");
		const neededVpcs = Object.keys(vpcGroups)
			.map((key) => orderBy(uniqBy(vpcGroups[key], "title"), "title"))
			.reduce((result, vpcs) => {
				return [
					...result,
					...vpcs.map((vpc) => `${vpc.title}${vpc.typeSequence ? ` [${vpc.typeSequence}]` : ""}`)
				];
			}, [])
			.join(", ");

		return neededVpcs;
	}
	get lessonPlanLocale(): any {
		return LessonPlanLocale;
	}

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}
}
